import React, { Component } from 'react'
import { both, clone, is, complement, equals, map, addIndex } from 'ramda'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import Box, { coordinateType } from './Box'
import './style.css'
import { NumberIcon } from './Icons'

const isValidPoint = (point = {}) => {
  const strictNumber = number => both(
    is(Number),
    complement(equals(NaN)),
  )(number)
  return strictNumber(point.x) && strictNumber(point.y)
}

class BoundingBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      boxCoordinate: {},
      dx: 10,
      dxt: 5
    }
  }

  drawingIndex = -1
  pointA = {}
  id = shortid.generate()

  handleMouseIn = (boxCoordinate, index) => {
    this.setState({
      dx: (10 / this.props.zoom + 5 / this.props.zoom) * (index + 1).toString().length,
      boxCoordinate: boxCoordinate,
      hover: true
    })
  }

  handleMouseOut = () => {
    this.setState({ hover: false })
  }

  renderCrops = (props) => {
    const indexedMap = addIndex(map)
    return indexedMap((boxCoordinate, index) =>
      (
        <div key={boxCoordinate.uniqueid} onMouseOver={() => this.handleMouseIn(boxCoordinate, index)} onMouseOut={this.handleMouseOut}>
          <div id="name-div" style={{ top: boxCoordinate.y + 5 / this.props.zoom, left: boxCoordinate.x + 5 / this.props.zoom, position: 'absolute' }}>
            <NumberIcon number={index + 1} zoom={12 / this.props.zoom} />
          </div>
          <Box
            key={boxCoordinate.id || index}
            index={index}
            coordinate={boxCoordinate}
            {...props}
          />
        </div>
      ))(props.coordinates)
  }

  getCursorPosition = (e) => {
    const { left, top } = this.container.getBoundingClientRect()
    return {
      x: e.clientX - left,
      y: e.clientY - top,
    }
  }

  handleMouseDown = (e) => {
    const { coordinates } = this.props
    if (e.target === this.img || e.target === this.container) {
      const { x, y } = this.getCursorPosition(e)
      this.drawingIndex = coordinates.length
      this.pointA = { x, y }
      this.id = shortid.generate()
    }
  }

  updateTooltipPosition = (coordinate) => {
    this.setState({ boxCoordinate: coordinate })
  }

  handleMouseMove = (e) => {
    const { onChange, coordinates, zoom } = this.props
    const { pointA } = this
    if (isValidPoint(pointA)) {
      const pointB = this.getCursorPosition(e)
      const coordinate = {
        x: Math.min(pointA.x, pointB.x) / zoom,
        y: Math.min(pointA.y, pointB.y) / zoom,
        width: Math.abs(pointA.x - pointB.x) / zoom,
        height: Math.abs(pointA.y - pointB.y) / zoom,
        id: this.id,
      }
      const nextCoordinates = clone(coordinates)
      nextCoordinates[this.drawingIndex] = coordinate
      if (is(Function, onChange)) {
        onChange(coordinate, this.drawingIndex, nextCoordinates)
      }
    }
  }

  handlMouseUp = () => {
    this.pointA = {}
  }


  render() {
    const { src, width, height, onLoad } = this.props
    return (
      <div style={{ position: 'relative', display: "inline-block" }}
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        onMouseUp={this.handlMouseUp}
        ref={container => this.container = container}
        id="multi-crop-image-div"
      >
        <div style={{
          background: '#262626', textAlign: "center", color: "white", opacity: 1, display: this.state.hover ? 'block' : 'none',
          top: this.state.boxCoordinate.y + 5 / this.props.zoom, left: this.state.boxCoordinate.x + this.state.dx,
          position: 'absolute', padding: '0px', fontSize: `${12 / this.props.zoom}px`
        }}>
          {this.state.boxCoordinate['classLabel'] ? this.state.boxCoordinate['classLabel'] : "unassigned"}</div>
        <img
          ref={img => this.img = img}
          src={src}
          width={width}
          height={height}
          onLoad={onLoad}
          alt=""
          draggable={false}
        />
        {this.renderCrops(this.props)}
      </div>
    )
  }
}

const { string, arrayOf, number, func } = PropTypes

BoundingBox.propTypes = {
  coordinates: arrayOf(coordinateType),
  src: string,
  width: number,
  height: number,
  onDraw: func,
  onChange: func,
  onLoad: func,
}

BoundingBox.defaultProps = {
  coordinates: [],
  src: '',
}

export default BoundingBox

